import { createRouter, createWebHistory } from 'vue-router'
import CatalogView from '@/views/CatalogView.vue'

const routes = [
  {
    path: '/',
    component: CatalogView
  },
  {
    path: '/cars/:id',
    component: () => import('../views/ProdInfoView.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/edit/:id',
    // name: 'EditView',
    component: () => import('../views/EditView.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/add',
    component: () => import('../views/AddView.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/about',
    component: () => import('../views/AboutView.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/:catchAll(.*)*',
    // name: "PageNotFound",
    component: () => import('../views/PageNotFound.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: "/vue-catalog/",
  routes
})

export default router